import { defineNuxtPlugin, useCookie } from '#app'

type SupportedLocale = 'en-US' | 'es-MX' | 'fr-FR' | 'de-DE'
// Keep reading the established locale cookie so deployment does not discard a
// returning visitor's previously selected or detected language.
const localeCookieName = 'cpx_locale'

export default defineNuxtPlugin(nuxtApp => {
    const rememberedLocale = useCookie<SupportedLocale | undefined>(
        localeCookieName
    )

    // Restore the remembered locale during plugin setup so the app starts in
    // the returning visitor's language before locale-aware components render.
    if (
        rememberedLocale.value === 'en-US' ||
        rememberedLocale.value === 'es-MX' ||
        rememberedLocale.value === 'fr-FR' ||
        rememberedLocale.value === 'de-DE'
    ) {
        nuxtApp.$i18n.locale.value = rememberedLocale.value
    }
})
